import { render, staticRenderFns } from "./travelers.vue?vue&type=template&id=2837a1aa&scoped=true&lang=html&"
import script from "./travelers.vue?vue&type=script&lang=js&"
export * from "./travelers.vue?vue&type=script&lang=js&"
import style0 from "./travelers.vue?vue&type=style&index=0&id=2837a1aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2837a1aa",
  null
  
)

export default component.exports